module.exports = __webpack_public_path__ + "img/pd-img-face1.553d5c3e.png";